import { render, staticRenderFns } from "./MainContainer.vue?vue&type=template&id=491b22ec&scoped=true"
import script from "./MainContainer.vue?vue&type=script&lang=js"
export * from "./MainContainer.vue?vue&type=script&lang=js"
import style0 from "./MainContainer.vue?vue&type=style&index=0&id=491b22ec&prod&lang=scss&scoped=true"
import style1 from "./MainContainer.vue?vue&type=style&index=1&id=491b22ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491b22ec",
  null
  
)

export default component.exports